import { track } from "@amplitude/analytics-react-native";
import { useCallback } from "react";
import PillButton from "src/components/PillButton";
import { useGatheringStore } from "src/contexts/GatheringContext";
import IconConfigure from "src/icons/IconConfigure";
import { useModal } from "src/modals";
import GatheringModal from "src/modals/configs/GatheringModal";
import useGatheringHomeNumColumnsRange from "src/screens/(internal)/(GatheringHome)/_/hooks/useGatheringHomeNumColumnsRange";

const FilterButton = () => {
	const gatheringId = useGatheringStore((state) => state.gatheringId);
	const setFiltersAndSort = useGatheringStore((state) => state.setFiltersAndSort);
	const getAllFilterSortSelections = useGatheringStore(
		(state) => state.getAllFilterSortSelections,
	);
	const { defaultNumColumns } = useGatheringHomeNumColumnsRange();
	const numFilters = useGatheringStore(
		(state) =>
			state.filterUserIds.length +
			state.filterPhotoVariant.length +
			state.filterUploaderIds.length +
			state.filterLabels.length +
			state.filterRestrictedLabels.length +
			+(state.numColumnsTarget != null && state.numColumnsTarget !== defaultNumColumns),
	);

	const { presentModal } = useModal<GatheringModal>();

	const handleFilterPress = useCallback(() => {
		track("gathering_filterSort_modalOpen");
		const initialConfig = getAllFilterSortSelections();
		presentModal("GatheringFilterSortModal", {
			props: { gatheringId, apply: setFiltersAndSort, ...initialConfig },
		});
	}, [gatheringId, setFiltersAndSort, presentModal, getAllFilterSortSelections]);

	return (
		<PillButton
			colorVariant={numFilters > 0 ? "Alt" : "Default"}
			opaque
			key="FilterButton"
			onPress={handleFilterPress}
			testID="GatheringNavBar-Filter"
			Icon={IconConfigure}
		>
			{numFilters > 0 ? `${numFilters}` : ""}
		</PillButton>
	);
};
export default FilterButton;
